module.exports = __webpack_public_path__ + "static/img/home2.7b178e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2.jpg
// module id = oIWM
// module chunks = 128